import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';
import React, { forwardRef, PropsWithChildren } from 'react';
import Slider from 'react-slick';
import Button from '../Button';
import { CarouselProps } from './Carousel.interface';
import useStyles from './Carousel.styles';

const Carousel = forwardRef<Slider, CarouselProps>(
  (
    {
      hasCustomDots,
      settings,
      className,
      children,
      theme,
      cta,
      next = () => {},
      prev = () => {},
      onChange = () => {},
    }: PropsWithChildren<CarouselProps>,
    ref,
  ) => {
    const classes = useStyles({ theme, settings });

    const appendDots = (dots: any) => {
      return (
        <div>
          {cta?.displayText && (
            <Button
              className={classes.linkContainer}
              variant="link"
              link={cta}
              endIcon={<ChevronRightIcon color="inherit" fontSize="small" />}
            />
          )}
          <div className={classes.dotsArrowsContainer}>
            <ChevronLeftIcon color="inherit" className={classes.dotsArrow} onClick={() => prev()} />
            <ul className={classes.dotsContainer}>{dots}</ul>
            <ChevronRightIcon
              color="inherit"
              className={classes.dotsArrow}
              onClick={() => next()}
            />
          </div>
        </div>
      );
    };

    const sliderSettings = {
      ...settings,
      ...(hasCustomDots && { appendDots }),
      dotsClass: clsx('slick-dots', cta && classes.withCta),
      beforeChange: (prevIndex: number, currentIndex: number) => onChange(prevIndex, currentIndex),
    };
    const rootClasses = clsx(
      classes.root,
      `${theme}-theme`,
      classes.slick,
      classes.slickTheme,
      className,
    );
    return (
      <Slider ref={ref} {...sliderSettings} className={rootClasses}>
        {children}
      </Slider>
    );
  },
);

export default Carousel;
